// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"53c24b3e","86":"b3993323","143":"e0764a48","202":"bde4f3bb","207":"9a417bde","232":"e17bd821","291":"68e872e0","331":"ea362d9d","381":"f37b08d3","389":"47687a5e","409":"1566a316","431":"06a32470","453":"dd81e8f4","525":"394c4b6c","732":"f6e928ad","819":"271c182b"}[chunkId] + ".chunk.js";
};